import React from 'react'
import context from '@/context'
import { DropDownList } from '@/components/dropDownList'

function EmployeeAssignmentDropDown ({ value, onChange }) {
  return (
    <DropDownList textField='name' dataSource={context.api.userService.getLookupForAssignment} value={value} onChange={onChange} />)
}

export {
  EmployeeAssignmentDropDown
}



// WEBPACK FOOTER //
// ./src/components/employeeAssignmentDropDown.js